import * as React from 'react';
export const IcBrush = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.5 11A4.75 4.75 0 004 15.5c0 2.81-.68 3.76-.74 3.82a1 1 0 00-.18 1.06A1 1 0 004 21c4.19 0 9-.62 9-5.5A4.75 4.75 0 008.5 11zm11.62-7.12a3 3 0 00-4.24 0l-5.45 5.44a7.001 7.001 0 014.22 4.27l5.47-5.47a3 3 0 000-4.24z'
      fill='currentColor'
    />
  </svg>
);
